<template>
  <el-form-item :error="errors.only_proxy_traffic">
    <el-checkbox v-model="value" @update:modelValue="input">
      Only proxy traffic
      <IconWithHint> Only proxy traffic </IconWithHint>
    </el-checkbox>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import useValidation from '@/hooks/useValidation'
import { CreativeValidationErrorsKey } from '@/api/types'
import IconWithHint from '@/components/IconWithHint.vue'

export default defineComponent({
  name: 'OnlyProxyTrafficInput',
  components: {
    IconWithHint
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const { validationErrors } = useValidation(CreativeValidationErrorsKey)
    const errors = validationErrors()

    function input(newValue: boolean) {
      context.emit('update:modelValue', newValue)
    }

    return { input, errors, value }
  }
})
</script>
